<template>
  <div class="order-container">
    <!-- 查询条件 -->
    <div class="search-form">
      <el-form :model="queryParams" inline>
        <el-form-item label="订单号">
          <el-input
            v-model="queryParams.orderNo"
            placeholder="请输入订单号"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="来源渠道">
          <el-select v-model="queryParams.channel" placeholder="请选择渠道" clearable style="width: 120px">
            <el-option label="线上" value="ONLINE" />
            <el-option label="线下" value="OFFLINE" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="queryParams.orderType" placeholder="请选择类型" clearable style="width: 160px">
            <el-option label="普通订单" value="普通订单" />
            <el-option label="销售订单" value="销售订单" />
            <el-option label="外卖" value="外卖" />
            <el-option label="堂食点餐" value="堂食点餐" />
            <el-option label="门店订单" value="门店订单" />
            <el-option label="拼团订单" value="拼团订单" />
            <el-option label="赠品" value="赠品" />
            <el-option label="代付" value="代付" />
          </el-select>
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select v-model="queryParams.refundStatus" placeholder="请选择" clearable style="width: 120px">
            <el-option label="无退款" value="无退款" />
            <el-option label="部分退款" value="部分退款" />
            <el-option label="全部退款" value="全部退款" />
          </el-select>
        </el-form-item>
        <el-form-item label="消费方式">
          <el-select v-model="queryParams.consumerType" placeholder="请选择" clearable style="width: 120px">
            <el-option label="会员消费" value="MEMBER" />
            <el-option label="非会员" value="NON_MEMBER" />
          </el-select>
        </el-form-item>
        <el-form-item label="消费店铺">
          <el-input
            v-model="queryParams.shopName"
            placeholder="请输入消费店铺"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="付款方式">
          <el-select v-model="queryParams.payMethod" multiple clearable placeholder="付款方式(多选)" style="width: 240px">
            <el-option v-for="item in payMethodOptions" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="queryParams.payTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button v-permission="'order:export'" type="warning" icon="el-icon-download" :loading="exportLoading" :disabled="exportStatus === 'RUNNING'" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 导出进度 -->
    <div v-if="exportTaskId" class="export-progress-section">
      <h3>导出进度</h3>
      <div v-if="exportStatus === 'RUNNING'" class="loading-progress">
        <div class="progress-bar-cycling"></div>
        <div class="progress-message">
          {{ exportTask.message || '正在生成文件...' }}
          <span v-if="exportTask.total > 0">（{{ exportTask.processed }}/{{ exportTask.total }}）</span>
        </div>
      </div>
      <div v-else-if="exportStatus === 'DONE'" class="progress-result">
        <el-progress :percentage="100" status="success" :stroke-width="20"></el-progress>
        <div class="progress-info">
          <span>总计: <strong>{{ exportTask.total }}</strong></span>
          <span class="text-success">已完成</span>
        </div>
        <div v-if="exportTask.message" class="progress-message">{{ exportTask.message }}</div>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>
      <div v-else-if="exportStatus === 'ERROR'" class="progress-error">
        <el-alert :title="exportTask.message || '导出失败'" type="error" :closable="false" show-icon></el-alert>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="content-wrapper">
      <el-table v-loading="tableLoading" :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="orderNo" label="订单号" width="250" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="channel" label="订单渠道" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.channel === 'ONLINE' ? 'primary' : 'warning'" size="small">
              {{ row.channel === 'ONLINE' ? '线上' : '线下' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="shopName" label="消费店铺" min-width="200" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.shopName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="orderType" label="订单类型" width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ getOrderTypeLabel(row.orderType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="会员昵称" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.nickname || '-' }}</template>
        </el-table-column>
        <el-table-column prop="youzanId" label="有赞会员ID" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.youzanId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="kemaiUserId" label="科脉会员ID" width="130" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.kemaiUserId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.phone && !row.phone.includes('*')" style="cursor: pointer" @click="handleViewMember(row.phone)">{{ row.phone }}</span>
            <span v-else>{{ row.phone || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="支付金额（元）" width="120" align="center">
          <template slot-scope="{ row }">{{ row.amount != null ? Number(row.amount).toFixed(2) : '0.00' }}</template>
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" min-width="160" align="center">
          <template slot-scope="{ row }">{{ fmtTime(row.payTime) }}</template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="95" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="orderStatusType(row.status)" size="small">{{ orderStatusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="payMethod" label="付款方式" width="120" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.payMethod || '-' }}</template>
        </el-table-column>
        <el-table-column prop="refundStatus" label="订单退款状态" width="105" align="center">
          <template slot-scope="{ row }">
            <span v-if="!row.refundStatus">-</span>
            <el-tag v-else :type="refundStatusType(row.refundStatus)" size="small">
              {{ refundStatusLabel(row.refundStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="refundAmount" label="已退款金额（元）" width="125" align="center">
          <template slot-scope="{ row }">
            {{ row.refundAmount != null ? Number(row.refundAmount).toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="itemCount" label="商品种类数" width="90" align="center">
          <template slot-scope="{ row }">{{ row.itemCount != null ? row.itemCount : '-' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="订单备注" width="120" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column prop="consumerType" label="消费方式" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.consumerType === 'MEMBER' ? 'success' : 'info'" size="small">
              {{ row.consumerType === 'MEMBER' ? '会员消费' : '非会员' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <Pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="detailVisible" width="1100px" top="5vh">
      <div v-if="detailData" v-loading="detailLoading">

        <!-- 基本信息 -->
        <div class="detail-section-title">基本信息</div>
        <el-descriptions :column="3" border size="small">
          <el-descriptions-item label="订单号" :span="2">{{ detailData.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="订单ID">{{ detailData.id }}</el-descriptions-item>
          <el-descriptions-item label="消费店铺">{{ detailData.shopName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="来源渠道">
            <el-tag :type="detailData.channel === 'ONLINE' ? 'primary' : 'warning'" size="small">
              {{ detailData.channel === 'ONLINE' ? '线上' : '线下' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="消费方式">
            <el-tag :type="detailData.consumerType === 'MEMBER' ? 'success' : 'info'" size="small">
              {{ detailData.consumerType === 'MEMBER' ? '会员消费' : '非会员' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="订单类型">{{ getOrderTypeLabel(detailData.orderType) }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="orderStatusType(detailData.status)" size="small">{{ orderStatusLabel(detailData.status) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="退款状态">
            <span v-if="!detailData.refundStatus">-</span>
            <el-tag v-else :type="refundStatusType(detailData.refundStatus)" size="small">
              {{ refundStatusLabel(detailData.refundStatus) }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 金额信息 -->
        <div class="detail-section-title" style="margin-top: 16px">金额信息</div>
        <el-descriptions :column="3" border size="small">
          <el-descriptions-item label="支付金额（元）">
            {{ detailData.amount != null ? Number(detailData.amount).toFixed(2) : '0.00' }}
          </el-descriptions-item>
          <el-descriptions-item label="退款金额（元）">
            {{ detailData.refundAmount != null ? Number(detailData.refundAmount).toFixed(2) : '0.00' }}
          </el-descriptions-item>
          <el-descriptions-item label="商品种类数">{{ detailData.itemCount != null ? detailData.itemCount : '-' }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">{{ detailData.payMethod || '-' }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ fmtTime(detailData.payTime) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="订单备注" :span="1">{{ detailData.remark || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 会员信息 -->
        <div class="detail-section-title" style="margin-top: 16px">会员信息</div>
        <el-descriptions :column="3" border size="small">
          <el-descriptions-item label="会员ID">{{ detailData.memberId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detailData.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="会员昵称">{{ detailData.nickname || '-' }}</el-descriptions-item>
          <el-descriptions-item label="有赞会员ID">{{ detailData.youzanId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="科脉会员ID">{{ detailData.kemaiUserId || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 支付方式明细 -->
        <template v-if="detailData.payList && detailData.payList.length > 0">
          <div class="detail-section-title" style="margin-top: 16px">支付方式明细</div>
          <el-table :data="detailData.payList" border size="small" style="width: 100%">
            <el-table-column prop="payMethodName" label="支付方式" align="center" />
            <el-table-column prop="transactionNo" label="第三方交易号" align="center" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.transactionNo || '-' }}</template>
            </el-table-column>
            <el-table-column prop="paySrc" label="支付凭证号" align="center" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.paySrc || '-' }}</template>
            </el-table-column>
            <el-table-column prop="payAmount" label="金额（元）" align="center">
              <template slot-scope="{ row }">
                {{ row.payAmount != null ? Number(row.payAmount).toFixed(2) : '0.00' }}
              </template>
            </el-table-column>
          </el-table>
        </template>

        <!-- 商品明细 -->
        <template v-if="detailData.items && detailData.items.length > 0">
          <div class="detail-section-title" style="margin-top: 16px">商品明细</div>
          <el-table :data="detailData.items" border size="small" style="width: 100%">
            <el-table-column prop="itemName" label="商品名称" min-width="140" align="center" show-overflow-tooltip />
            <el-table-column prop="itemCode" label="商品编码" width="120" align="center" />
            <el-table-column prop="quantity" label="数量" width="70" align="center" />
            <el-table-column prop="unit" label="单位" width="60" align="center" />
            <el-table-column prop="unitPrice" label="单价（元）" width="100" align="center">
              <template slot-scope="{ row }">
                {{ row.unitPrice != null ? Number(row.unitPrice).toFixed(2) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="discountAmount" label="优惠金额（元）" width="115" align="center">
              <template slot-scope="{ row }">
                {{ row.discountAmount != null ? Number(row.discountAmount).toFixed(2) : '0.00' }}
              </template>
            </el-table-column>
            <el-table-column prop="saleAmount" label="销售金额（元）" width="115" align="center">
              <template slot-scope="{ row }">
                {{ row.saleAmount != null ? Number(row.saleAmount).toFixed(2) : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="shipStatus" label="发货状态" width="90" align="center">
              <template slot-scope="{ row }">{{ shipStatusLabel(row.shipStatus) }}</template>
            </el-table-column>
            <el-table-column prop="afterSaleStatus" label="售后状态" width="90" align="center">
              <template slot-scope="{ row }">{{ afterSaleStatusLabel(row.afterSaleStatus) }}</template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <div slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, getOrderDetail } from '@/api/order'
import { submitExport, getExportTask, downloadExport } from '@/api/export'
import request from '@/utils/request'
import Pagination from '@/components/Pagination/index.vue'

export default {
  name: 'OrderManage',
  components: { Pagination },
  data() {
    return {
      queryParams: {
        orderNo: '',
        phone: '',
        channel: '',
        orderType: '',
        refundStatus: '',
        consumerType: '',
        shopName: '',
        payMethod: [],
        payTimeRange: [],
        pageNum: 1,
        pageSize: 10
      },
      orderTypeOptions: [
        '普通订单', '销售订单', '外卖', '堂食点餐', '门店订单',
        '拼团订单', '赠品', '代付', '心愿单', '二维码订单',
        '合并付货款', '品鉴', '返利', '酒店', '外卖买单',
        '全员开店', '线下收银台订单', '美业预约单', '美业服务单',
        '知识付费', '礼品卡', '直播带货订单', '样品订单', '批发'
      ],
      payMethodOptions: [
        '优惠兑换', '储值卡(统一)', '微信代销支付', '未知', '有赞零钱', '享钱-支付宝支付',
        '享钱-微信支付', '现金', '自动抹零', '会员支付-储值余额支付', '优惠券-纸质满减券',
        '优惠券-电子兑换券', '团购券-抖音券', '有赞储值卡', '享钱-银联二维码支付', '挂账',
        '会员支付-购物卡支付', '优惠券-电子满减券', '团购券-新美大券(餐饮)', '其他支付(62)',
        '支付不出票', '银行扫码', '抖音券核销'
      ],
      tableLoading: false,
      exportLoading: false,
      tableData: [],
      total: 0,
      detailVisible: false,
      detailLoading: false,
      detailData: null,
      // 异步导出状态
      exportTaskId: null,
      exportStatus: '',
      exportTask: {},
      exportPollingTimer: null
    }
  },
  created() {
    this.getList()
    this.recoverExportProgress()
  },
  beforeDestroy() {
    this.stopExportPolling()
  },
  methods: {
    fmtTime(val) {
      return val ? String(val).replace('T', ' ') : ''
    },
    getList() {
      // 深分页保护：超过1000页时提示选择时间范围
      if (this.queryParams.pageNum > 1000) {
        this.$message.warning('数据量较大，请先选择支付时间范围进行筛选')
        this.queryParams.pageNum = 1000
        return
      }
      this.tableLoading = true
      const params = { ...this.queryParams }
      if (params.payTimeRange && params.payTimeRange.length === 2) {
        params.startTime = params.payTimeRange[0]
        params.endTime = params.payTimeRange[1]
      }
      delete params.payTimeRange
      // 付款方式：数组转逗号串，空则删除
      if (params.payMethod && params.payMethod.length) {
        params.payMethod = params.payMethod.join(',')
      } else {
        delete params.payMethod
      }
      // orderType 为空时不传
      if (!params.orderType) {
        delete params.orderType
      }
      getOrderList(params).then(res => {
        this.tableData = res.data.records || res.data.list || []
        this.total = res.data.total || 0
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },

    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    // 查看会员详情
    handleViewMember(phone) {
      this.$router.push({ path: '/member', query: { phone } })
    },

    handleReset() {
      this.queryParams = {
        orderNo: '',
        phone: '',
        channel: '',
        orderType: '',
        refundStatus: '',
        consumerType: '',
        shopName: '',
        payMethod: [],
        payTimeRange: [],
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },

    handleExport() {
      const params = { ...this.queryParams, pageNum: undefined, pageSize: undefined }
      if (params.payTimeRange && params.payTimeRange.length === 2) {
        params.startTime = params.payTimeRange[0]
        params.endTime = params.payTimeRange[1]
      }
      delete params.payTimeRange
      // 付款方式：数组转逗号串，空则删除
      if (params.payMethod && params.payMethod.length) {
        params.payMethod = params.payMethod.join(',')
      } else {
        delete params.payMethod
      }
      if (!params.orderType) delete params.orderType

      this.exportLoading = true
      submitExport('order', params).then(res => {
        this.exportTaskId = res.data.taskId
        this.exportStatus = 'RUNNING'
        this.exportTask = { message: res.data.message || '正在生成文件...' }
        this.startExportPolling()
      }).catch(err => {
        this.$message.error(err.message || '导出提交失败')
      }).finally(() => {
        this.exportLoading = false
      })
    },

    recoverExportProgress() {
      const cached = sessionStorage.getItem('orderExportTask')
      if (!cached) return
      try {
        const { taskId } = JSON.parse(cached)
        getExportTask(taskId).then(res => {
          const task = res.data
          if (task.status === 'RUNNING') {
            this.exportTaskId = taskId
            this.exportStatus = 'RUNNING'
            this.exportTask = task
            this.startExportPolling()
          } else if (task.status === 'DONE' || task.status === 'ERROR') {
            this.exportTaskId = taskId
            this.exportStatus = task.status
            this.exportTask = task
          } else {
            sessionStorage.removeItem('orderExportTask')
          }
        }).catch(() => {
          sessionStorage.removeItem('orderExportTask')
        })
      } catch (e) {
        sessionStorage.removeItem('orderExportTask')
      }
    },

    startExportPolling() {
      this.stopExportPolling()
      sessionStorage.setItem('orderExportTask', JSON.stringify({ taskId: this.exportTaskId }))
      this.pollExportTask()
      this.exportPollingTimer = setInterval(() => {
        this.pollExportTask()
      }, 3000)
    },

    pollExportTask() {
      getExportTask(this.exportTaskId).then(res => {
        const task = res.data
        this.exportTask = task
        this.exportStatus = task.status
        if (task.status === 'DONE' || task.status === 'ERROR') {
          this.stopExportPolling()
          if (task.status === 'DONE') {
            this.autoDownloadExport()
          }
        }
      }).catch(() => {
        this.exportStatus = 'ERROR'
        this.exportTask = { message: '查询进度失败' }
        this.stopExportPolling()
      })
    },

    stopExportPolling() {
      if (this.exportPollingTimer) {
        clearInterval(this.exportPollingTimer)
        this.exportPollingTimer = null
      }
    },

    autoDownloadExport() {
      if (!this.exportTaskId) return
      downloadExport(this.exportTaskId).then(() => {
        this.$message.success('导出完成，文件已下载')
      }).catch(() => {
        this.$message.error('下载失败')
      })
    },

    clearExportTask() {
      this.exportTaskId = null
      this.exportStatus = ''
      this.exportTask = {}
      this.stopExportPolling()
      sessionStorage.removeItem('orderExportTask')
    },

    handleDetail(row) {
      this.detailData = null
      this.detailVisible = true
      this.detailLoading = true
      getOrderDetail(row.id).then(res => {
        this.detailData = res.data
      }).catch(() => {
        this.$message.error('获取详情失败')
        this.detailVisible = false
      }).finally(() => {
        this.detailLoading = false
      })
    },

    // 订单类型标签（数据库已存中文，直接展示）
    getOrderTypeLabel(val) {
      return val || '-'
    },

    // 订单状态颜色（兼容英文旧值 + 中文新值）
    orderStatusType(status) {
      const map = {
        // 中文值（数据库当前存储）
        '已支付': 'success', '交易成功': 'success', '已完成': 'success',
        '待付款': 'warning', '待确认': 'warning', '待发货': 'warning', '待收货': 'warning',
        '已取消': 'info', '交易关闭': 'info', '未支付': 'info',
        // 英文旧值（历史数据兼容）
        PAID: 'success',
        PENDING: 'warning',
        CANCELLED: 'info',
        REFUNDED: 'danger',
        PARTIAL_REFUND: 'warning',
        PARTIALLY_REFUNDED: 'warning'
      }
      return map[status] || 'info'
    },

    // 订单状态标签（数据库已存中文，直接展示；兼容旧英文值）
    orderStatusLabel(status) {
      if (!status) return '-'
      const map = {
        // 英文旧值兜底
        PAID: '已支付', PENDING: '待付款', CANCELLED: '已取消',
        REFUNDED: '已退款', PARTIAL_REFUND: '部分退款', PARTIALLY_REFUNDED: '部分退款'
      }
      return map[status] || status
    },

    // 发货状态中文标签
    shipStatusLabel(status) {
      if (!status) return '-'
      const map = {
        UNSHIPPED: '未发货',
        SHIPPED: '已发货',
        RECEIVED: '已收货',
        RETURNED: '已退货'
      }
      return map[status] || status
    },

    // 售后状态中文标签
    afterSaleStatusLabel(status) {
      if (!status) return '-'
      const map = {
        NONE: '无售后',
        AFTER_SALE: '有售后',
        REFUNDING: '退款中',
        REFUNDED: '已退款',
        RETURNING: '退货中',
        RETURNED: '已退货',
        PARTIAL_REFUND: '部分退款',
        PARTIAL_RETURN: '部分退货',
        REJECTED: '已拒绝',
        CANCELLED: '已取消'
      }
      return map[status] || status
    },

    // 退款状态颜色（兼容中英文）
    refundStatusType(s) {
      if (!s) return 'info'
      const map = {
        // 中文值
        '无退款': 'success',
        '部分退款': 'warning',
        '全部退款': 'danger',
        // 英文旧值兜底
        NO_REFUND: 'success', REFUNDING: 'warning', REFUNDED: 'danger',
        PARTIAL: 'warning', PARTIAL_REFUND: 'warning', FULL_REFUND: 'danger'
      }
      return map[s] || 'info'
    },

    // 退款状态标签（数据库已存中文，直接展示；兼容英文旧值）
    refundStatusLabel(s) {
      if (!s) return '-'
      const map = {
        NO_REFUND: '无退款', REFUNDING: '退款中', REFUNDED: '已退款',
        PARTIAL: '部分退款', PARTIAL_REFUND: '部分退款', FULL_REFUND: '全部退款'
      }
      return map[s] || s
    },
  }
}
</script>

<style lang="less" scoped>
.order-container {
  height: 100%;
}
.detail-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}
.json-viewer {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  font-size: 12px;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
}

/* 导出进度 */
.export-progress-section {
  margin: 16px 20px;
  padding: 16px 20px;
  background: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  h3 {
    font-size: 16px;
    margin: 0 0 16px;
  }
  .loading-progress {
    .progress-bar-cycling {
      height: 20px;
      border-radius: 10px;
      background: #EBEEF5;
      position: relative;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 30%;
        height: 100%;
        background: #409EFF;
        border-radius: 10px;
        animation: export-cycling 2s ease-in-out infinite;
      }
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
      text-align: center;
    }
  }
  .progress-result {
    .progress-info {
      display: flex;
      gap: 16px;
      margin-top: 12px;
      font-size: 14px;
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
    }
    .action-buttons {
      margin-top: 16px;
    }
  }
  .progress-error {
    .action-buttons {
      margin-top: 12px;
    }
  }
}

@keyframes export-cycling {
  0% { left: -30%; }
  50% { left: 100%; }
  100% { left: -30%; }
}

.text-success { color: #67C23A; }
</style>
